// @flow

export type Action = {
  type: 'PUB_SUB_MESSAGE',
  payload: {
    channel: string,
    topic: string,
    message: mixed,
  },
};

export default function pubSubMessage(channel: string, topic: string, message: mixed): Action {
  return {
    type: 'PUB_SUB_MESSAGE',
    payload: {
      channel,
      topic,
      message,
    },
  };
}
